import { mapGetters, mapActions } from 'vuex'

export const fielStorageActions = {
  ...mapActions('fielStorage', [
    'validateFiel',
    'setOnSuccessFiel',
    'resetFiel',
    'cleaned',
    'setFielRfcToCompare'
  ])
}

export const fielStorageData = {
  ...mapGetters('fielStorage', [
    'fiel',
    'fielErrorMessage',
    'onSuccessFiel',
    'clean',
    'rfcToCompare'
  ])
}
